import { AutogenModelDispatch, AutogenRowDispatch } from "./autogen/AutogenModelDispatch";

export class ModelDispatch extends AutogenModelDispatch<RowDispatch> {
    constructor() {
        super(RowDispatch);
    }
}

export class RowDispatch extends AutogenRowDispatch {
}